<template>
	<div class="container">
		<ul class="nav nav-tabs" :id="name">
	  		<li class="nav-item" v-for="tab in tabs">
	    		<button 
	    			class="nav-link" 
	    			:id="name+tab.field" 
	    			@click="tab_change(tab.field)">
	    			{{ tab.label }}
	    		</button>
	  		</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
	        tabs: {
	            type: Array
	        },
	        name: {
	        	type: String
	        }
	    },

		mounted(){
			// set o primeiro enviado como ativo
			var el = document.getElementById(this.name+this.tabs[0]['field']);
			el.classList.add("active");
		},

		methods: {
			tab_change(tab){
				for (var i=0; i<this.tabs.length; i++) {
					if($('#'+this.name+this.tabs[i]['field']).hasClass('active')){
						document.getElementById(this.name+this.tabs[i]['field']).classList.remove("active");
					}
				}

				var el = document.getElementById(this.name+tab)
				el.classList.add("active");

				this.$emit('tabChanged', tab);
			},
		}
	}
</script>

<style scoped>
	#bsh-tab button {
		background-color: white;
	}
	.active {
		color: blue !important;
	}
</style>